import { useEffect } from "react";
import { updateAppBadge } from "../utils/AppBadgeUtils";

export const useAppBadge = (count: number, enabled: boolean): void => {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    void updateAppBadge(count);
  }, [count, enabled]);
};
